@if (isPublicRoute) {
  <app-alert></app-alert>
  <router-outlet></router-outlet>
}
@else if (appAuthService.isRegionNotSupported$()) {
  <app-alert></app-alert>
  <div class="flex min-h-screen w-full flex-col items-center justify-center bg-[#050914] text-slate-50 px-4 py-12">
    <div class="w-full max-w-md rounded-2xl border border-white/5 bg-slate-900/60 p-6 shadow-2xl text-center backdrop-blur-md">
      <!-- Icon -->
      <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-red-500/10 text-red-400">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
        </svg>
      </div>

      <h2 class="text-xl font-semibold mb-2 text-white">Profile Not Supported</h2>
      <p class="text-sm text-slate-400 mb-6">
        Your profile is not supported in <span class="font-semibold text-slate-200">{{ currentRegionDisplayName$() }}</span>.
      </p>

      @if (homeRegion$(); as home) {
        <p class="text-xs text-slate-500 mb-6">
          Please switch back to your home region to access your account.
        </p>
        <button 
          type="button" 
          (click)="switchRegionBack()" 
          class="w-full rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-indigo-500 active:scale-[0.98] shadow-lg shadow-indigo-600/25"
        >
          Switch to {{ home.displayName }}
        </button>
      } @else {
        <p class="text-xs text-slate-500 mb-6">
          Please switch to your home region to access your account.
        </p>
        <div class="flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
          @for (region of supportedRegions; track region.id) {
            <button 
              type="button" 
              (click)="switchToSpecificRegion(region.id)" 
              class="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white transition hover:bg-white/10 active:scale-[0.98] text-left flex justify-between items-center"
            >
              <span>{{ region.displayName }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-slate-400">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </button>
          }
        </div>
      }
    </div>
  </div>
}
@else {
  @if (impersonation.state$().active) {
    <div class="impersonation-banner">
      <span>Currently impersonating {{ impersonation.state$().targetDisplayName || impersonation.state$().targetIdentityUserId }}</span>
      <button type="button" (click)="impersonation.stop()" [disabled]="impersonation.loading$()">Stop</button>
    </div>
  }
  @if (shouldShowOnboardingProgress) {
    <app-my-onboarding-progress [progress]="onboarding.status$()"></app-my-onboarding-progress>
  }
  <app-alert></app-alert>
  <router-outlet></router-outlet>
}
